import React from 'react';
import RTCCustomView from 'components/atoms/rtcView';
import {useTheme} from 'contexts/ThemeContext';
import {getFirstLettersFromUsername} from 'helpers/getFirstLettersFromUsername';
import {ConferenceUser} from 'models/ConferenceUser';
import {Image, Platform, Text, View} from 'react-native';
import strings from 'translations';
import styleSheet from './styles';

export interface ConferencePersonProps {
  index: number;
  isSharing: boolean;
  user: ConferenceUser;
  width: number;
  height: number;
}

const ConferencePerson = (props: ConferencePersonProps) => {
  const theme = useTheme();
  const styles = styleSheet(
    theme,
    props.isSharing,
    props.width,
    !!props.user.reaction,
    !props.user.stream.isAudioEnabled,
  );

  const NameView = (
    <View style={styles.topContainer}>
      <View style={styles.nameContainer}>
        <Text style={styles.name} numberOfLines={1}>
          {props.user.isLocal
            ? strings.conferenceScreen.you
            : props.user.username}
        </Text>
      </View>
      <View style={styles.microOffAndReactionContainer}>
        {!props.user.stream.isAudioEnabled && (
          <Image style={styles.microOffImage} source={theme.images.microOff} />
        )}
        {props.user.reaction && (
          <View style={styles.reactionContainer}>
            <Text style={styles.reaction}>{props.user.reaction}</Text>
          </View>
        )}
      </View>
    </View>
  );

  const UserView = !props.user.stream.isVideoEnabled && (
    <View style={styles.userContainer}>
      <Text style={styles.userText}>
        {props.user.isLocal
          ? strings.conferenceScreen.you
          : getFirstLettersFromUsername(props.user.username)}
      </Text>
    </View>
  );

  const ContentView = (
    <>
      {NameView}
      {UserView}
    </>
  );

  return props.user.stream.isVideoEnabled || Platform.OS === 'web' ? (
    <RTCCustomView
      id={props.user.connectionId}
      stream={props.user.stream}
      isVideoEnabled={props.user.stream.isVideoEnabled}
      isSharing={props.user.isSharing}
      isMyStream={props.user.isLocal}
      style={[styles.container, {width: props.width, height: props.height}]}>
      {ContentView}
    </RTCCustomView>
  ) : (
    <View
      style={[styles.container, {width: props.width, height: props.height}]}>
      {ContentView}
    </View>
  );
};

export default ConferencePerson;
